import React, { useState, useContext } from 'react';
import { Button, Form, Grid, Header, Message, Segment } from 'semantic-ui-react';
import { useMutation } from '@apollo/client';
import { useNavigate } from 'react-router-dom';

import { AuthContext } from '../context/auth';
import { CREATE_EMPLOYEE } from '../utils/graphqlQueries';

function CreateEmployee() {
    const context = useContext(AuthContext);
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [values, setValues] = useState({
        username: '',
        email: '',
        password: ''
    });

    const [createEmployee, { loading }] = useMutation(CREATE_EMPLOYEE, {
        update(_, { data: { createEmployee: employeeData } }) {
            setErrors({});
            // Show success message or redirect
            alert(`Employee ${employeeData.username} created successfully!`);
            // Reset form
            setValues({
                username: '',
                email: '',
                password: ''
            });
        },
        onError(err) {
            console.log(err.graphQLErrors);
            setErrors(err.graphQLErrors[0]?.extensions?.errors || { general: err.message });
        },
        variables: values
    });

    const onChange = (event) => {
        setValues({ ...values, [event.target.name]: event.target.value });
    };

    const onSubmit = (event) => {
        event.preventDefault();
        createEmployee();
    };

    // Check if user is Company role (only Company users can create employees)
    if (!context.user || context.user.role === 'Employee') {
        return (
            <Grid textAlign='center' style={{ height: '80vh' }} verticalAlign='middle'>
                <Grid.Column style={{ maxWidth: 450 }}>
                    <Header as='h2' color='red' textAlign='center'>
                        Access Denied
                    </Header>
                    <Message error>
                        Only Company users can create employees.
                    </Message>
                </Grid.Column>
            </Grid>
        );
    }

    return (
        <Grid textAlign='center' style={{ height: '80vh' }} verticalAlign='middle'>
            <Grid.Column style={{ maxWidth: 450 }}>
                <Header as='h2' color='teal' textAlign='center'>
                    Create Employee
                </Header>
                <Form onSubmit={onSubmit} noValidate className={loading ? 'loading' : ''}>
                    <Segment stacked>
                        <Form.Input
                            label='Username'
                            placeholder='Username'
                            name='username'
                            type='text'
                            value={values.username}
                            error={errors.username ? true : false}
                            onChange={onChange}
                        />
                        <Form.Input
                            label='Email'
                            placeholder='Email'
                            name='email'
                            type='email'
                            value={values.email}
                            error={errors.email ? true : false}
                            onChange={onChange}
                        />
                        <Form.Input
                            label='Password'
                            placeholder='Password'
                            name='password'
                            type='password'
                            value={values.password}
                            error={errors.password ? true : false}
                            onChange={onChange}
                        />
                        <Button color='teal' fluid size='large'>
                            Create Employee
                        </Button>
                    </Segment>
                </Form>
                {Object.keys(errors).length > 0 && (
                    <Message error>
                        <Message.Header>There were some errors with your submission</Message.Header>
                        <Message.List>
                            {Object.values(errors).map((value) => (
                                <Message.Item key={value}>{value}</Message.Item>
                            ))}
                        </Message.List>
                    </Message>
                )}
            </Grid.Column>
        </Grid>
    );
}

export default CreateEmployee;
